import React from 'react';
import {Slider} from 'MWC';
import pay1 from '../../img/googlepay1.svg';
import pay2 from '../../img/googlepay2.svg';
import image from '../../img/left_img.png';
import '../../less/payment-notice.less';

export default function template() {
    return (
        <div className="module-payment-notice-container">
            <div className="module-content-wrapper">
                <div className="main-payment-notice-content">
                    <div className="left-side">
                        <div className="slider-container">
                            <img src={image} />
                        </div>
                    </div>
                    <div className="right-side">
                        <p className="main-title">{this.l10n('GOOGLE_PAY_PAYMENT_CARD')}</p>
                        <p className="desc">{this.l10n('GOOGLE_PAY_PAYMENT_CARD_TEXT_1')}</p>
                        <p className="info">{this.l10n('GOOGLE_PAY_PAYMENT_NOTICE')}</p>
                        <div className="sign-wrapper">
                            <div>
                                <img src={pay1} alt="" />
                                <img src={pay2} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
